// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2p8Bn","label":"SetPasswdForm_label__2ugkN"};